"use client";

import { useComebackUrl } from "@/components/hooks/use-comeback-url";
import { pagesPath } from "@/utils/pages-path";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

function Fallback({ homePath }: { homePath: string }) {
  const router = useRouter();
  useEffect(() => {
    router.push(homePath);
  }, [homePath, router]);
  return <div />;
}

export function MemberDefaultGuestOnlyFallback() {
  const homePath = pagesPath.members.$url().path;
  return <Fallback homePath={homePath} />;
}

export function EmployerDefaultGuestOnlyFallback() {
  const homePath = pagesPath.employers.$url().path;
  return <Fallback homePath={homePath} />;
}

export function HealthInsuranceSocietyStaffDefaultGuestOnlyFallback() {
  const { getComebackUrl } = useComebackUrl();
  const homePath = getComebackUrl() ?? pagesPath.admin.$url().path;
  return <Fallback homePath={homePath} />;
}
